import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import logo from "../../img/icon.png";
import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
} from "@mui/material";
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useSnackbar } from "notistack";
import AppMain from "../../App";
import { useEffect, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 5,
  boxShadow: 24,
  p: 4,
};

export default function LoginModal() {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [user1, setCurrentUser] = useState(null);

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setCurrentUser(currentUser);
        handleClose();
      } else {
        setCurrentUser(null);
        handleOpen();
      }
    });
  });

  const login = async () => {
    try {
      const user = await signInWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );
      //   console.log(user);
      enqueueSnackbar("Logged In", { variant: "default" });
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      console.log(error.message);
    }
  };

  const [values, setValues] = React.useState({
    email: "",
    password: "",
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return user1 ? (
    <AppMain />
  ) : (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Stack>
            <Box justifyContent="center" sx={{ display: "flex" }}>
              <Box component="img" src={logo}></Box>
            </Box>
            <Typography textAlign="center">Juba Mall</Typography>
            <Typography textAlign="center" variant="h6" sx={{ mb: 3 }}>
              Login
            </Typography>
          </Stack>

          <TextField
            sx={{ mb: 4 }}
            id="email"
            fullWidth
            label="Email"
            type="email"
            variant="outlined"
            onChange={handleChange("email")}
          />
          <FormControl sx={{ mb: 4 }} fullWidth variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={values.showPassword ? "text" : "password"}
              value={values.password}
              onChange={handleChange("password")}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? (
                      <VisibilityOff width={30} />
                    ) : (
                      <Visibility width={30} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
          </FormControl>

          <Button
            onClick={login}
            variant="contained"
            disableElevation
            sx={{ width: "100%", height: 50, borderRadius: 1 }}
          >
            Login
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
}
